/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resource_Newsletter_DescriptionInputs */

const en_blog_resource_newsletter_description = /** @type {(inputs: Blog_Resource_Newsletter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask to receive the weekly product discovery brief.`)
};

const zh_blog_resource_newsletter_description = /** @type {(inputs: Blog_Resource_Newsletter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申请接收每周产品发现简报。`)
};

/**
* | output |
* | --- |
* | "Ask to receive the weekly product discovery brief." |
*
* @param {Blog_Resource_Newsletter_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resource_newsletter_description = /** @type {((inputs?: Blog_Resource_Newsletter_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resource_Newsletter_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resource_newsletter_description(inputs)
	return zh_blog_resource_newsletter_description(inputs)
});
export { blog_resource_newsletter_description as "blog.resource_newsletter_description" }